import Header from "./components/Header/Header";
import React from "react";
import Footer from "./components/Footer/Footer";
import PrivacyText from "./components/Privacy/PrivacyText";

const Privacy = () => {
  return (
    <>
      <div className="min-h-screen bg-background text-center">
        <Header />
        <div className="flex pb-10 pt-20 justify-center gap-2">
          <PrivacyText />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Privacy;
